import { VideoIcon } from 'lucide-react';
import LibrasIcon from '~/assets/audiodescription';
import AudioGuideIcon from '~/assets/audioguide';
import AudioDescriptionIcon from '~/assets/libras';
import type { MediaType } from './types';

export const getMediaIcon = (type: MediaType, fill: string) => {
  switch (type) {
    case 'audioguide':
      return <AudioGuideIcon fill={fill} />;
    case 'audiodescription':
      return <AudioDescriptionIcon fill={fill} />;
    case 'signlanguage':
      return <LibrasIcon fill={fill} />;
    case 'video':
      return <VideoIcon size={16} stroke={fill} />;
    default:
      return null;
  }
};
